import OppositeLegLink from './OppositeLegLink';

export default OppositeLegLink;
